export const Constants = {
    /**
     * Endereço padrão do servidor
     */
    BASE_URL: '/api',

    /**
     * Quantidade de usuários carregados por padrão
     */
    USUARIOS: 15,

    /**
     * Textos diversos de exibição na aplicação
     */
    MSG_LISTAGEM_USUARIOS: 'Nenhum Usuário Encontrado.',
    MSG_ERRO_AUTENTICACAO: 'Erro na autenticação. Por favor, verifique suas credenciais e tente novamente.'
};
